module.exports = __webpack_public_path__ + "static/media/me3_Heart_Outline_Icon.1ebc256b.svg";